/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown> }} Notifications_Message_Body_LowInputs */

const he_notifications_message_body_low = /** @type {(inputs: Notifications_Message_Body_LowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`מינימום ${i?.price}`)
};

const en_notifications_message_body_low = /** @type {(inputs: Notifications_Message_Body_LowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`low ${i?.price}`)
};

/**
* | output |
* | --- |
* | "low {price}" |
*
* @param {Notifications_Message_Body_LowInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_message_body_low = /** @type {((inputs: Notifications_Message_Body_LowInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Message_Body_LowInputs, { locale?: "he" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_message_body_low(inputs)
	return en_notifications_message_body_low(inputs)
});